<template>
  <router-view/>
</template>

<style>
@font-face {
  font-family: "Neo Sans";
  src: url("./assets/fonts/Neo Sans Std Regular.otf") format("opentype");
}

@font-face {
  font-family: "Neo Sans";
  font-weight: bold;
  src: url("./assets/fonts/Neo Sans Std Bold.otf") format("opentype");
}

body {
  font-family: "Neo Sans", sans-serif;
}
</style>
